<template>
    <section class="lymphomap_main">
        <div class="user_left_to_room">
            <div class="user_left_inner_wrp">
                <h2>You left the room</h2>
                <div class="user_left_btn">
                    <router-link :to="'/video/conference/' + this.hasGetFromRoute"
                        class="btn btn-primary mr-3">Rejoin</router-link>
                    <router-link class="btn btn-primary" :to="{ name: 'DashboardMain' }">Return to Home</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
export default {
    name: 'user-left-room',
    components: {},
    props: [],
    data() {
        return {
            hasGetFromRoute: ''
        }
    },
    computed: {

    },
    mounted() {
        this.hasGetFromRoute = this.$route.hash
    },
    methods: {

    },
    beforeCreate: function () {
    },
    beforeRouteLeave: function (to, from, next) {
        next();
    },
}
</script>
<style lang="scss" scoped>
.user_left_inner_wrp {
    background: rgba(0, 0, 0, 0.7);
    max-width: 400px;
    text-align: center;
    padding: 35px;
    border-radius: 5px;
    box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.1), -3px -3px 3px rgba(255, 255, 255, 0.1);
    margin: 0 auto;
    width: 100%;
    font-family: 'lato', sans-serif;
}

.user_left_to_room {
    padding-top: 80px;
}

.user_left_inner_wrp h2 {
    font-size: 26px;
    font-weight: 600;
    color: #ffffc1;
    margin-bottom: 40px;
}

.user_left_btn .btn-primary {
    background: rgba(255, 255, 255, 0.1);
    border: none !important;
    color: #fff;
    padding: 5px 14px;
    display: inline-block;
    border-radius: 4px;
    font-size: 18px;
    outline: none !important;
    box-shadow: none !important;

    &:hover {
        background: #87cefa;
        color: #000;
    }
}

@media only screen and (max-width:767px) {
    .user_left_inner_wrp {
        padding: 15px;
    }
}
</style>